import _ from 'lodash';

import { createApiReducer } from 'src/api';

import {
  ADD_WEBSITE_START,
  ADD_WEBSITE_SUCCESS,
  ADD_WEBSITE_FAILURE,
  UPDATE_WEBSITE_START,
  UPDATE_WEBSITE_SUCCESS,
  UPDATE_WEBSITE_FAILURE,
  DELETE_WEBSITE_START,
  DELETE_WEBSITE_SUCCESS,
  DELETE_WEBSITE_FAILURE,
} from './actions';

export const transformWebsite = response => ({
  id: response.id,
  url: response.website_url,
});

const updateItem = (list, key, value, newItem) => {
  return list.map(item => {
    if (item[key] === value) {
      return newItem;
    }
    return item;
  });
};

const accountAddWebsiteReducer = createApiReducer(
  [ADD_WEBSITE_START, ADD_WEBSITE_SUCCESS, ADD_WEBSITE_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      websites: [...state.data.websites, transformWebsite(payload)],
    };
  },
  error => transformWebsite(_.get(error, 'payload.response', {}))
);

const accountDeleteWebsiteReducer = createApiReducer(
  [DELETE_WEBSITE_START, DELETE_WEBSITE_SUCCESS, DELETE_WEBSITE_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      websites: state.data.websites.filter(d => d.id !== payload.id),
    };
  },
  error => transformWebsite(_.get(error, 'payload.response', {}))
);

const updateWebsite = (payload, state) => {
  const newWebsite = transformWebsite(payload);

  return {
    ...state.data,
    websites: updateItem(state.data.websites, 'id', newWebsite.id, newWebsite),
  };
};

const accountUpdateWebsiteReducer = createApiReducer(
  [UPDATE_WEBSITE_START, UPDATE_WEBSITE_SUCCESS, UPDATE_WEBSITE_FAILURE],
  updateWebsite,
  error => transformWebsite(_.get(error, 'payload.response', {}))
);

export const reducers = [
  accountAddWebsiteReducer,
  accountUpdateWebsiteReducer,
  accountDeleteWebsiteReducer,
];
